import React, { useState, useEffect } from "react";
import { FormGroup } from "reactstrap";
import DataTable from "react-data-table-component";
import { faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BlurSpinner } from "../../../components/BlurSpinner";
import ConfirmPdfModal from "./ConfirmPdfModal";
import { fetchProcedimiento, postProcedimientoPdf } from "../../../services/procedimientoService";
import ModalProcedimientos from "../Tabs/ModalProcedimiento";
import useFetcher from "../../../hooks/useFetcher";
import { ButtonPrimary } from "../../../ui/buttons";

const TablaProcedimiento = ({ clientId, isAdmin, isOwner, isAudit, filesComponent }) => {
  const [procedimientosModal, setProcedimientosModal] = useState(false);
  const [procedimientoSelected, setProcedimientoSelected] = useState();
  const [procedimiento, isLoadingProcedimiento, , , refreshProcedimiento] = useFetcher(fetchProcedimiento, [clientId]);
  const [pdfModal, setPdfModal] = useState(false);
  const [isLoadingPdfButton, setIsLoadingPdfButton] = useState(false);
  useEffect(async () => {
    refreshProcedimiento();
  }, [procedimientosModal]);
  const createPdfProcedimiento = async () => {
    if (procedimientoSelected.id) {
      setIsLoadingPdfButton(true);
      await postProcedimientoPdf(procedimientoSelected.id);
      filesComponent.current.refreshFiles();
      setPdfModal(!pdfModal);
      setIsLoadingPdfButton(false);
    }
  };
  return (
    <div style={{ fontFamily: "Nunito" }}>
      <BlurSpinner isLoading={isLoadingProcedimiento}>
        {procedimientosModal && (
          <ModalProcedimientos
            toggle={() => setProcedimientosModal(!procedimientosModal)}
            client={clientId || 1}
            procedimientos={procedimientoSelected}
            isAdmin={isAdmin}
            isOwner={isOwner}
          />
        )}
        {pdfModal && (
          <ConfirmPdfModal
            toggle={() => {
              setPdfModal(!pdfModal);
            }}
            handleSubmitArea={createPdfProcedimiento}
            isLoading={isLoadingPdfButton}
          />
        )}

        <div className="mt-3">
          <div className="d-flex flex-row justify-content-end align-items-center mb-3">
            <FormGroup className="mb-0">
              {(isAdmin || isOwner) && !isAudit && (
                <ButtonPrimary
                  className="btn"
                  disabled={false}
                  onClick={() => {
                    setProcedimientoSelected({});
                    setProcedimientosModal(!procedimientosModal);
                  }}
                >
                  Nuevo Procedimiento
                </ButtonPrimary>
              )}
            </FormGroup>
          </div>
          {procedimiento && (
            <DataTable
              className="table-procedimiento"
              onRowClicked={(row) => {
                if (isAudit) return;
                setProcedimientoSelected(row);
                setProcedimientosModal(!procedimientosModal);
              }}
              columns={[
                {
                  name: "Versiones",
                  selector: (row) => row.title || "-",
                  sortable: true,
                  center: true,
                  id: "title",
                  style: {
                    cursor: "pointer",
                    textAlign: "center",
                    // borderRight: "1px solid #e5e5e5",
                  },
                },
                {
                  name: "Ultima Actualización",
                  selector: (row) => {
                    const day = row.updatedAt.slice(8, 10);
                    const month = row.updatedAt.slice(5, 7);
                    const year = row.updatedAt.slice(0, 4);
                    return `${day}/${month}/${year}    ${row.updatedAt.slice(11, 16)} hs - ${row.updated.nombreApellido}` || "-";
                  },
                  sortable: true,
                  center: true,
                  id: "ultimaActualizacion",
                  style: {
                    cursor: "pointer",
                    textAlign: "center",
                  },
                },
                {
                  name: "pdf",
                  selector: (row) => (isAdmin || isOwner || isAudit ? row.id : null),
                  cell: (row) =>
                    isAdmin || isOwner ? (
                      <FontAwesomeIcon
                        onClick={() => {
                          setProcedimientoSelected(row);
                          setPdfModal(true);
                        }}
                        icon={faFilePdf}
                        style={{ color: "red", fontSize: "20px", background: "white", border: "1px solid white", cursor: "pointer" }}
                      />
                    ) : null,
                  center: true,
                  id: "pdf",
                  style: {
                    cursor: "pointer",
                    textAlign: "center",
                  },
                },
              ]}
              data={procedimiento && procedimiento !== undefined ? procedimiento.rows : []}
              noDataComponent={<div className="p-3">no hay datos</div>}
              responsive
              striped
              hover
            />
          )}
        </div>
      </BlurSpinner>
    </div>
  );
};
export default TablaProcedimiento;
